module.exports = __webpack_public_path__ + "img/REQ.cb7c94bf.svg";